module.exports = __webpack_public_path__ + "static/media/productie.bec16c91.png";